export const PERMISSION_DELIMITER = '_'
